module.exports = __webpack_public_path__ + "static/media/logo-dot-white.c2be8cc9.svg";